import {ICONS} from '../constants/icons';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  seo: {
    lang: 'pl',
    title: 'Zespół redakcyjny HelloFinance',
    description: 'Poznaj redaktorów i recenzentów merytorycznych odpowiedzialnych za tworzenie treści na HelloFinance – to dzięki nim w naszych artykułach znajdujesz wyłącznie informacje zgodne z aktualnym prawodawstwem i analizami finansowymi.'
  },

  genericHeading: {
    heading: "Zespół redakcyjny HelloFinance",
    breadcrumbsIcon: ICONS.home,
    breadcrumbs: [
      {
        label: 'Home',
        href: '/',
        title: 'Home'
      },
      {
        label: 'O nas',
        href: '/o-nas',
      },
      {
        label: 'Redakcja'
      }
    ]
  },

  teamContent: {
    heading: 'Zespół redakcyjny',
    // eslint-disable-next-line max-len
    description: 'HelloFinance to portal, w ramach którego oferujemy naszym czytelnikom niezbędną wiedzę o finansach osobistych. Pomagamy Wam podejmować mądre decyzje finansowe i budujemy wiedzę oraz świadomość ekonomiczną.',
    // eslint-disable-next-line max-len
    descriptionBottom: 'Najważniejsza jest dla nas dziennikarska i naukowa rzetelność. Dlatego wszystkie treści, które piszemy przechodzą proces skrupulatnej recenzji merytorycznej. Współpracujemy z niezależnym panelem ekspertów – prawników, ekonomistów i analityków finansowych. Każdy tekst, który zostaje opublikowany na naszej stronie jest wcześniej weryfikowany przez eksperta.',
    // picture: {
    //   sm: '/images/cacao-bloom-zespol-sm.jpg',
    //   md: '/images/cacao-bloom-zespol-md.jpg',
    //   alt: 'Składniki aktywne - Cacao Bloom'
    // }
  },
}
